<template>
    <div>
        <div class="share_con" @click="$emit('doCloseShare')">
            <img src="../assets/img/share.png">
        </div>
        <div class="share_bg"></div>
    </div>
</template>

<script>
    export default {
    }
</script>

<style scoped>
.share_bg{
  width: 100%;
  height: 100%;
  background: #000;
  left: 0;
  top: 0;
  opacity: 0.8;
  position: fixed;
  z-index: 10;
}
.share_con{
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 11;
  text-align: right;
}
.share_con img{
  width: 154px;
  display: inline-block;
  padding: 48px 33px 0 0;
}
</style>